import { render, staticRenderFns } from "./imgread.vue?vue&type=template&id=3eca57f4&scoped=true&"
import script from "./imgread.vue?vue&type=script&lang=js&"
export * from "./imgread.vue?vue&type=script&lang=js&"
import style0 from "./imgread.vue?vue&type=style&index=0&id=3eca57f4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eca57f4",
  null
  
)

export default component.exports